// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
// Vue.use(ElementUI, { locale })

// 引入专业的chunk错误处理工具
import { setupGlobalErrorHandler, setupRouterErrorHandler } from '@/utils/chunkErrorHandler'

// 引入公共JS
import "@/assets/iconfont/iconfont.css";
import '../static/css/ckeditor.css';
import '../static/css/index.css';
import '@/assets/js/commin.js';
// 引入公共上传进度条样式
import '@/assets/styles/upload-progress.css';
Vue.config.productionTip = false
import './permission' // permission control

// 引入Vue懒加载 npm install vue-contextmenujs
import VueLazyload from 'vue-lazyload';

// 引入右侧菜单
import Contextmenu from "vue-contextmenujs";

import App from './App'
import router from './router'
import store from './store'

// 设置全局错误处理
setupGlobalErrorHandler();

// 设置路由错误处理
setupRouterErrorHandler(router);

Vue.use(Contextmenu);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/img/loading.gif'),
  loading: require('./assets/img/loading.gif'),
  attempt: 1
});

// 引入svg icon
import VueFoldable from 'vue-foldable';
import 'vue-foldable/dist/vue-foldable.css';

import '@/icons';

Vue.component('foldable', VueFoldable)

// 引入自定义指令
Vue.directive('focus', {
  inserted: function (el) {
    el.setAttribute('tabindex', -1);
    el.focus();
  }
})

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDrag', {

  bind(el, binding, vnode, oldVnode) {
    //弹框可拉伸最小宽高
    let minWidth = 400;
    let minHeight = 300;
    //初始非全屏
    let isFullScreen = false;

    //当前宽高
    let nowWidth = 0;
    let nowHight = 0;

    //当前顶部高度
    let nowMarginTop = 0;
    //获取弹框头部（这部分可双击全屏）
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    //弹窗
    const dragDom = el.querySelector('.el-dialog');
    //给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
    dragDom.style.overflow = "auto";
    //清除选择头部文字效果
    //dialogHeaderEl.onselectstart = new Function("return false");
    //头部加上可拖动cursor
    dialogHeaderEl.style.cursor = 'move';
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
    let moveDown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;
      // 获取到的值带px 正则匹配替换
      let styL, styT;
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      } else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      };
      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX;
        const t = e.clientY - disY;
        // 移动当前元素
        dragDom.style.left = `${l + styL}px`;
        dragDom.style.top = `${t + styT}px`;
        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }

    dialogHeaderEl.onmousedown = moveDown;
    //双击头部全屏效果
    dialogHeaderEl.ondblclick = (e) => {
      if (isFullScreen == false) {
        nowHight = dragDom.clientHeight;
        nowWidth = dragDom.clientWidth;
        nowMarginTop = dragDom.style.marginTop;
        dragDom.style.left = 0;
        dragDom.style.top = 0;
        dragDom.style.height = "100VH";
        dragDom.style.width = "100VW";
        dragDom.style.marginTop = 0;
        isFullScreen = true;
        dialogHeaderEl.style.cursor = 'initial';
        dialogHeaderEl.onmousedown = null;
      } else {
        dragDom.style.height = "auto";
        dragDom.style.width = nowWidth + 'px';
        dragDom.style.marginTop = nowMarginTop;
        isFullScreen = false;
        dialogHeaderEl.style.cursor = 'move';
        dialogHeaderEl.onmousedown = moveDown;
      }
    }

    dragDom.onmousemove = function (e) {
      let moveE = e;
      if (e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10 || dragDom.offsetLeft + 10 > e.clientX) {
        dragDom.style.cursor = 'w-resize';
      } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10) {
        dragDom.style.cursor = 's-resize';
      } else {
        dragDom.style.cursor = 'default';
        dragDom.onmousedown = null;
      }

      dragDom.onmousedown = (e) => {
        const clientX = e.clientX;
        const clientY = e.clientY;
        let elW = dragDom.clientWidth;
        let elH = dragDom.clientHeight;
        let EloffsetLeft = dragDom.offsetLeft;
        let EloffsetTop = dragDom.offsetTop;
        // 只在拖拽时禁用文本选择，不影响输入框
        if (!el.querySelector('input, textarea, [contenteditable="true"]')) {
        dragDom.style.userSelect = 'none';
        }
        let ELscrollTop = el.scrollTop;
        //判断点击的位置是不是为头部

        if (clientX > EloffsetLeft && clientX < EloffsetLeft + elW && clientY > EloffsetTop && clientY < EloffsetTop + 100) {
          //如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;
        }else{
          document.onmousemove = function (e) {
            e.preventDefault(); // 移动时禁用默认事件
            //左侧鼠标拖拽位置
            if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {
              //往左拖拽
              if (clientX > e.clientX) {
                dragDom.style.width = elW + (clientX - e.clientX) * 2 + 'px';
              }

              //往右拖拽
              if (clientX < e.clientX) {
                if(dragDom.clientWidth < minWidth){
                }else{
                  dragDom.style.width = elW - (e.clientX - clientX) * 2 + 'px';
                }
              }
            }

            //右侧鼠标拖拽位置
            if (clientX > EloffsetLeft + elW - 10 && clientX < EloffsetLeft + elW) {
              //往左拖拽
              if (clientX > e.clientX) {
                if (dragDom.clientWidth < minWidth) {

                } else {
                  dragDom.style.width = elW - (clientX - e.clientX) * 2 + 'px';
                }
              }

              //往右拖拽
              if (clientX < e.clientX) {
                dragDom.style.width = elW + (e.clientX - clientX) * 2 + 'px';
              }
            }

            //底部鼠标拖拽位置
            if (ELscrollTop + clientY > EloffsetTop + elH - 20 && ELscrollTop + clientY < EloffsetTop + elH) {
              //往上拖拽
              if (clientY > e.clientY) {
                if (dragDom.clientHeight < minHeight) {
                } else {
                  dragDom.style.height = elH - (clientY - e.clientY) * 2 + 'px';
                }
              }

              //往下拖拽
              if (clientY < e.clientY) {
                dragDom.style.height = elH + (e.clientY - clientY) * 2 + 'px';
              }
            }
          };

          //拉伸结束
          document.onmouseup = function (e) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        }
      }
    }
  }
})


// 管理html元信息
import VueMeta from 'vue-meta'
Vue.use(VueMeta)

// 引入社会化分享插件
import Share from 'vue-social-share'
Vue.use(Share);

import xss from 'xss'
// 定义全局XSS解决方法
Object.defineProperty(Vue.prototype, '$xss', {
  value: xss
})

import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
Vue.use(mavonEditor)

// 引入全局工具类hljs
import prototype from './utils/prototype'
Vue.use(prototype)

// 引入抽奖模块
import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)

Vue.directive('highlight', function (el) {
  let blocks = el.querySelectorAll('pre code');
  blocks.forEach((block) => {
    hljs.highlightBlock(block)
  })
})

// 引入数学公式
import MathJax from './assets/js/MathJax.js'
Vue.prototype.MathJax = MathJax

import VueParticles from 'vue-particles'
Vue.use(VueParticles)

// 引入WebSocket管理器
import webSocketManager from '@/utils/WebSocketManager'
import { getCookie } from '@/utils/cookieUtils'
import { SET_LOGIN_STATE } from '@/store/mutation-types'

// 创建全局事件总线
Vue.prototype.$bus = new Vue()

// 全局WebSocket连接管理
Vue.prototype.$initGlobalWebSocket = function() {
  const token = getCookie('token')
  if (token && !webSocketManager.isConnected()) {
    console.log('全局初始化WebSocket连接')
    webSocketManager.connect().then(() => {
      console.log('全局WebSocket连接成功')
    }).catch(error => {
      console.error('全局WebSocket连接失败:', error)
    })
  }
}

// 全局WebSocket断开连接
Vue.prototype.$disconnectGlobalWebSocket = function() {
  if (webSocketManager.isConnected()) {
    console.log('全局断开WebSocket连接')
    webSocketManager.disconnect()
  }
}

// 全局WebSocket生命周期管理
Vue.prototype.$manageGlobalWebSocket = function(isLogin) {
  if (isLogin) {
    this.$initGlobalWebSocket()
  } else {
    this.$disconnectGlobalWebSocket()
  }
}

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    // 应用启动时初始化WebSocket连接
    this.$nextTick(() => {
      this.$initGlobalWebSocket()
    })
    
    // 监听登录状态变化，自动管理WebSocket连接
    this.$store.watch(
      (state) => state.isLogin,
      (newValue, oldValue) => {
        console.log('登录状态变化:', oldValue, '->', newValue)
        this.$manageGlobalWebSocket(newValue)
      }
    )
  }
})



// WEBPACK FOOTER //
// ./src/main.js